import { clearStoredAuth } from "./storage";

const handleLogout = () => {
  clearStoredAuth();
};

export { handleLogout };
